import React, { useEffect,useState,useRef } from "react";
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import labelIcon from 'assets/icons/manual_label.svg'
import arrowViewAllIcon from 'assets/icons/arrow_viewall_manual.svg'
import arrowViewTopicIcon from 'assets/icons/arrow_topic_manual.svg'
import axios from "axios";
import "./manual.scss"
import { Link ,useNavigate } from "react-router-dom";


const ManualPortal = ()=>{
    const { t } = useTranslation();
    const hash = window.location.hash;
    const navigate = useNavigate(); 

    const queryParams = useParams();

    const mainCategoryId = queryParams.mainCategoryId

    const [sideMainCategories,setSideMainCategories] = useState()
    const refs = useRef({}); // Store dynamic refs in an object

    
    const setRef = (id) => (el) => {
      refs.current[id] = el; // Assign ref dynamically based on the id
    };

    const scrollTo = (id) => {
        refs.current[id]?.scrollIntoView({ behavior: "smooth", block: "center" });
      };
useEffect(()=>{
    const main_categories = async ()=>{
        const categories = await axios.get(`https://gis247.net/wp-json/content-api/manual/get-manual-main-categories-with-sub-by-id?mainCatId=${mainCategoryId}`);
        
       

        console.log(categories.data,'main_categories');
        setSideMainCategories(categories.data);
    }
    main_categories()
    if (hash) {
        const elementId = hash.substring(1); // Remove the '#'
        console.log(elementId,'elementId')
        scrollTo(elementId)
    }

}, [window.location.hash])
    return (
        <>
        <div className="main-content-wrapper-body">
            <div className="main-content-wrapper-body-top-bar d-flex align-items-center justify-content-between">
                <div className="main-content-wrapper-body-top-bar-left">
                <h1 className="main-content-wrapper-body-top-bar-left-heading fw-semibold mb-0">
                    
                  
                   <span className="non_active"> <Link to="/app/admin/manual">{t("User Manual")}  </Link> </span>  
                 
                    <span className="arrow-suparate"><img src={arrowViewTopicIcon} className="arrow_img"/>
                    </span> 
                    <span className="active">{sideMainCategories?sideMainCategories.main_category_name:""}</span>
                </h1>
                </div>
    
           
                
            </div>    
    
                 <div className="manual_view_wrp">
                    <div className="row">
                                <div className="col-md-3">

                                        <ul className="side_list_manual_categories_non_topic">
<h3><img src={labelIcon} className="label_side"/> Section </h3>
{sideMainCategories?sideMainCategories.sub_category.map((v)=>{

 let linkCategories =  v.layout==="with_portal" ? `/app/admin/view-manual/portal/${v.id}`: `/app/admin/view-manual/${v.id}/${v.parent_id}`

//   const topicLink = vc.sidebar_style==="scroll"?`/app/admin/view-manual/${vc.id}#${v.section_title}`:`/app/admin/view-manual/page/${vc.id}#${v.section_title}`

    return (
        <li>
        <h4><img src={arrowViewTopicIcon} className="arrow_img"/> 
        <Link to={linkCategories}>{v.name} </Link>
        
        </h4>

  
       
    </li>

    )
}):""}
                                     

                                        </ul>
                                </div>
    
                                <div className="col-md-9 ">
                                <div className="manual_content_wrp">

                                    <h2 className="category_header">{sideMainCategories?sideMainCategories.main_category_name:""}</h2>
                                {sideMainCategories?sideMainCategories.sub_category.map((v,k)=>{
    return (
        <div className="manual_content_list_wrp">
        <h4>{v.name}</h4>

        {v.post?v.post.map((vp,kp)=>{
            const linkTopic= v.post_sidebar_style==="link_to_topic" ? `/app/admin/view-manual/topic/${vp.category}/${vp.post_category_id}/${vp.id}`: `/app/admin/view-manual/${vp.category}/${vp.post_category_id}/#${vp.section_title}`
            return (
                <div className="manual_description" key={kp} id={vp.section_title} ref={setRef(vp.section_title)} onClick={()=>{
                    navigate(linkTopic, { replace: true })
                }}>
                    
                 
                     <h5 className="link_topic"><img src={labelIcon} className="label_side"/> {vp.heading_th}</h5>
    
            </div>
            )
        }):""}
       
    </div>

    )
}):""}
                                </div>
                                </div>
                    </div>
                   
    
                </div>    



          </div>        
            </>
    )
}

export default ManualPortal;